export const AI_IMAGE_EVENTS = {
    URL_CHANGE: "URL_CHANGE",
    CANCEL: 'cancel',
    SAVE: 'save',
    REPLACE: 'replace'
};